var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowUp = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 10,
  viewBox: "0 0 18 10",
  fill: "none",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C8.65424 0 8.35932 0.127827 8.09492 0.393314L0.335594 8.06293C0.111866 8.26942 0 8.54474 0 8.85939C0 9.49852 0.508474 10 1.17966 10C1.50508 10 1.8 9.87217 2.02373 9.65585L9 2.74336L15.9763 9.65585C16.2102 9.87217 16.5051 10 16.8305 10C17.4915 10 18 9.49852 18 8.85939C18 8.54474 17.8881 8.26942 17.6644 8.06293L9.90508 0.393314C9.64068 0.127827 9.34576 0.00983284 9 0Z",
  fill: "#757E79"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.08246fcf.svg";
export { ForwardRef as ReactComponent };